import React, { useState, Fragment } from 'react';
import { Clock, ChevronLeft, ChevronRight, ArrowUpDown, ChevronDown, ChevronUp, X, Eye } from 'lucide-react';
interface WebhookLogEntry {
  id: string;
  webhookType: string;
  url: string;
  timestamp: string;
  requestPayload: object;
  responseBody: object;
  httpStatus: number;
  httpStatusText: string;
}
const MOCK_LOGS: WebhookLogEntry[] = [{
  id: 'log-001',
  webhookType: 'Transaction-level',
  url: 'https://cinema.bilamart.my/genie-hook.php',
  timestamp: '22/04/2026 08:51:54',
  requestPayload: {
    eventId: '69e83ed2e7af0b2f03dde478',
    eventType: 'NOTIFY_TRANSACTION_CHANGE',
    data: {
      transactionId: '69e83c658b0ec431315543e4',
      amount: 767600,
      currency: 'MYR',
      state: 'CANCELLED',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://cinema.bilamart.my/genie-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-002',
  webhookType: 'Transaction-level',
  url: 'https://uat.cimb.com.my/payge-hook.php',
  timestamp: '22/04/2026 08:51:53',
  requestPayload: {
    eventId: '69e83ed1a4b7c20f8a1de592',
    eventType: 'NOTIFY_TRANSACTION_CHANGE',
    data: {
      transactionId: '69e83c658b0ec431315543e4',
      amount: 767600,
      currency: 'MYR',
      state: 'CANCELLED',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://uat.cimb.com.my/payge-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-003',
  webhookType: 'Transaction-level',
  url: 'https://cinema.bilamart.my/genie-hook.php',
  timestamp: '22/04/2026 00:20:53',
  requestPayload: {
    eventId: '69e7d4f5c3a8910e7b2cf301',
    eventType: 'NOTIFY_TRANSACTION_CHANGE',
    data: {
      transactionId: '69e7d4a19c0ef5123abc7890',
      amount: 250000,
      currency: 'MYR',
      state: 'APPROVED',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://cinema.bilamart.my/genie-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-004',
  webhookType: 'Transaction-level',
  url: 'https://uat.cimb.com.my/payge-hook.php',
  timestamp: '22/04/2026 00:20:52',
  requestPayload: {
    eventId: '69e7d4f4b2c7810d6a1be200',
    eventType: 'NOTIFY_TRANSACTION_CHANGE',
    data: {
      transactionId: '69e7d4a19c0ef5123abc7890',
      amount: 250000,
      currency: 'MYR',
      state: 'APPROVED',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://uat.cimb.com.my/payge-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-005',
  webhookType: 'Transaction-level',
  url: 'https://cinema.bilamart.my/genie-hook.php',
  timestamp: '21/04/2026 16:58:49',
  requestPayload: {
    eventId: '69e6c3a9d5f1020e8c3df412',
    eventType: 'NOTIFY_TOKENISATION_STATUS',
    data: {
      tokenId: '69e6c3509b1ef6234def8901',
      status: 'ACTIVE',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://cinema.bilamart.my/genie-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-006',
  webhookType: 'Transaction-level',
  url: 'https://uat.cimb.com.my/payge-hook.php',
  timestamp: '21/04/2026 16:58:48',
  requestPayload: {
    eventId: '69e6c3a8c4e0f10d7b2ce301',
    eventType: 'NOTIFY_TOKENISATION_STATUS',
    data: {
      tokenId: '69e6c3509b1ef6234def8901',
      status: 'ACTIVE',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://uat.cimb.com.my/payge-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-007',
  webhookType: 'Transaction-level',
  url: 'https://cinema.bilamart.my/genie-hook.php',
  timestamp: '21/04/2026 16:56:50',
  requestPayload: {
    eventId: '69e6c332e6g2130f9d4eg523',
    eventType: 'NOTIFY_TRANSACTION_CHANGE',
    data: {
      transactionId: '69e6c2e0ad2fg7345efg9012',
      amount: 150000,
      currency: 'MYR',
      state: 'SETTLED',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://cinema.bilamart.my/genie-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-008',
  webhookType: 'Transaction-level',
  url: 'https://uat.cimb.com.my/payge-hook.php',
  timestamp: '21/04/2026 16:56:49',
  requestPayload: {
    eventId: '69e6c331d5f1020e8c3df412',
    eventType: 'NOTIFY_TRANSACTION_CHANGE',
    data: {
      transactionId: '69e6c2e0ad2fg7345efg9012',
      amount: 150000,
      currency: 'MYR',
      state: 'SETTLED',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://uat.cimb.com.my/payge-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-009',
  webhookType: 'Transaction-level',
  url: 'https://cinema.bilamart.my/genie-hook.php',
  timestamp: '21/04/2026 10:59:53',
  requestPayload: {
    eventId: '69e66f89a7h4350b0f6gi734',
    eventType: 'NOTIFY_TRANSACTION_CHANGE',
    data: {
      transactionId: '69e66f309e3gh8456fgh0123',
      amount: 500000,
      currency: 'MYR',
      state: 'APPROVED',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://cinema.bilamart.my/genie-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}, {
  id: 'log-010',
  webhookType: 'Transaction-level',
  url: 'https://uat.cimb.com.my/payge-hook.php',
  timestamp: '21/04/2026 10:59:53',
  requestPayload: {
    eventId: '69e66f88b8i5460c1g7hj845',
    eventType: 'NOTIFY_TRANSACTION_CHANGE',
    data: {
      transactionId: '69e66f309e3gh8456fgh0123',
      amount: 500000,
      currency: 'MYR',
      state: 'APPROVED',
      companyId: '6397f39df07fba000842a90b'
    }
  },
  responseBody: {
    url: 'https://uat.cimb.com.my/payge-hook.php',
    status: 200,
    statusText: 'OK',
    ok: true
  },
  httpStatus: 200,
  httpStatusText: 'OK'
}];
function truncateUrl(url: string, maxLen = 30) {
  if (url.length <= maxLen) return url;
  return url.substring(0, maxLen) + '...';
}
/* ── Centralised style tokens (mapped from theme/tokens.css) ── */
const styles = {
  btnPrimary: 'text-white rounded-md font-medium text-sm transition-all bg-[var(--brand-primary)] hover:bg-[var(--brand-primaryhover)] focus:outline-none focus:ring-2 focus:ring-[var(--brand-primaryring)]',
  btnGhost: 'text-sm text-[var(--colors-text-secondary)] bg-[var(--colors-background-card)] border border-[var(--colors-border-default)] rounded-md hover:bg-[var(--colors-neutral-50)] transition-colors',
  card: 'bg-[var(--colors-background-card)] border border-[var(--colors-border-light)] rounded-lg shadow-[var(--shadows-sm)]',
  heading: 'text-[var(--colors-text-primary)] font-semibold',
  subtext: 'text-sm text-[var(--colors-text-tertiary)]',
  label: 'block text-sm font-medium text-[var(--colors-text-secondary)] mb-1',
  input: 'w-full border border-[var(--colors-border-default)] rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[var(--brand-primaryring)] focus:border-[var(--colors-border-focus)] bg-[var(--colors-background-card)]',
  th: 'px-6 py-3 font-medium text-[var(--colors-text-secondary)] cursor-pointer hover:bg-[var(--colors-neutral-50)]',
  badgeBase: 'inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium border',
  link: 'text-sm font-medium text-[var(--brand-primary)] hover:text-[var(--brand-primaryhover)] transition-colors'
} as const;
export function WebhookLogs() {
  const [timestamp, setTimestamp] = useState('');
  const [httpStatus, setHttpStatus] = useState('');
  const [webhookType, setWebhookType] = useState('All');
  const [transactionId, setTransactionId] = useState('');
  const [showAdditionalFilters, setShowAdditionalFilters] = useState(false);
  const [activeFilters, setActiveFilters] = useState<{
    key: string;
    value: string;
  }[]>([]);
  const [expandedPayloads, setExpandedPayloads] = useState<Record<string, boolean>>({});
  const [expandedResponses, setExpandedResponses] = useState<Record<string, boolean>>({});
  const [perPage, setPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const handleSearch = () => {
    const filters = [];
    if (timestamp) filters.push({
      key: 'timestamp',
      value: `Timestamp: ${timestamp}`
    });
    if (httpStatus) filters.push({
      key: 'httpStatus',
      value: `Status: ${httpStatus}`
    });
    if (webhookType !== 'All') filters.push({
      key: 'webhookType',
      value: `Type: ${webhookType}`
    });
    if (transactionId) filters.push({
      key: 'transactionId',
      value: `Txn: ${transactionId}`
    });
    setActiveFilters(filters);
    setCurrentPage(1);
  };
  const clearFilters = () => {
    setTimestamp('');
    setHttpStatus('');
    setWebhookType('All');
    setTransactionId('');
    setActiveFilters([]);
    setCurrentPage(1);
  };
  const removeFilter = (keyToRemove: string) => {
    setActiveFilters(activeFilters.filter(f => f.key !== keyToRemove));
    if (keyToRemove === 'timestamp') setTimestamp('');
    if (keyToRemove === 'httpStatus') setHttpStatus('');
    if (keyToRemove === 'webhookType') setWebhookType('All');
    if (keyToRemove === 'transactionId') setTransactionId('');
  };
  const togglePayload = (id: string) => {
    setExpandedPayloads(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  const toggleResponse = (id: string) => {
    setExpandedResponses(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  // Filter logs based on active filters
  const filteredLogs = MOCK_LOGS.filter(log => {
    if (activeFilters.find(f => f.key === 'httpStatus')) {
      if (String(log.httpStatus) !== httpStatus) return false;
    }
    if (activeFilters.find(f => f.key === 'webhookType')) {
      if (log.webhookType !== webhookType) return false;
    }
    if (activeFilters.find(f => f.key === 'transactionId')) {
      const payload = JSON.stringify(log.requestPayload);
      if (!payload.toLowerCase().includes(transactionId.toLowerCase())) return false;
    }
    return true;
  });
  const totalPages = Math.max(1, Math.ceil(filteredLogs.length / perPage));
  const paginatedLogs = filteredLogs.slice((currentPage - 1) * perPage, currentPage * perPage);
  const startEntry = filteredLogs.length === 0 ? 0 : (currentPage - 1) * perPage + 1;
  const endEntry = Math.min(currentPage * perPage, filteredLogs.length);
  const statusBadgeColor = (status: number) => {
    if (status >= 200 && status < 300) return 'bg-[var(--colors-success-light)] text-[var(--colors-success-dark)] border-[var(--colors-primary-200)]';
    if (status >= 400 && status < 500) return 'bg-[var(--colors-warning-light)] text-[var(--colors-warning-dark)] border-[var(--colors-warning-default)]';
    return 'bg-[var(--colors-error-light)] text-[var(--colors-error-dark)] border-[var(--colors-error-default)]';
  };
  return <div className="max-w-7xl mx-auto p-6 space-y-6" data-id="element-5735" data-mp="2yvvgcaphhirz">
      {/* Header */}
      <div className={`${styles.card} p-6`} data-id="element-5736" data-mp="35yjv3hrniiie">
        <h1 className={`text-xl ${styles.heading}`} data-id="element-5737" data-mp="3awbokg7y2cop">Webhook Logs</h1>
        <p className={`${styles.subtext} mt-1`} data-id="element-5738" data-mp="3awlg488n0rwi">
          Webhook delivery attempts for the last 30 days
        </p>
      </div>

      {/* Filters */}
      <div className={`${styles.card} p-6 space-y-6`} data-id="element-5739" data-mp="3kmn5d3cq8gd0">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end" data-id="element-5740" data-mp="3ko7ycoje7r8r">
          <div data-id="element-5741" data-mp="3omxc4i8cfasx">
            <label className={styles.label} data-id="element-5742" data-mp="3ongug01wo17h">Timestamp</label>
            <input type="text" value={timestamp} onChange={e => setTimestamp(e.target.value)} placeholder="Timestamp" className={styles.input} data-id="element-5743" data-mp="3tm0chpddosuk" />
          </div>
          <div data-id="element-5744" data-mp="7dion6839md0">
            <label className={styles.label} data-id="element-5745" data-mp="247vamjs3yx0j">HTTP status</label>
            <select value={httpStatus} onChange={e => setHttpStatus(e.target.value)} className={styles.input} data-id="element-5746" data-mp="249g74exzgq11">
              <option value="" data-id="element-5747" data-mp="qc3oq0675gnd">Select</option>
              <option value="200" data-id="element-5748" data-mp="qdyblk113iu3">200</option>
              <option value="201" data-id="element-5749" data-mp="lkls1ob7i287">201</option>
              <option value="400" data-id="element-5750" data-mp="lju511vodctj">400</option>
              <option value="401" data-id="element-5751" data-mp="hj0f62yo9ny0">401</option>
              <option value="403" data-id="element-5752" data-mp="hjs0mkyk25ak">403</option>
              <option value="404" data-id="element-5753" data-mp="ckp6vwo0zlhw">404</option>
              <option value="500" data-id="element-5754" data-mp="cm0bfypaoxa2">500</option>
              <option value="502" data-id="element-5755" data-mp="19ag0ltoht4mn">502</option>
              <option value="503" data-id="element-5756" data-mp="199el9d0g1vz4">503</option>
            </select>
          </div>
          <div data-id="element-5757" data-mp="15a5vej8iyi8u">
            <button onClick={handleSearch} className={`${styles.btnPrimary} w-full px-4 py-2`} data-id="element-5758" data-mp="15afju2dx8hcf">
              Search
            </button>
          </div>
        </div>

        {showAdditionalFilters && <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4 border-t border-[var(--colors-neutral-100)]" data-id="element-5759" data-mp="3l08x0mtegnsq">
            <div data-id="element-5760" data-mp="3g0mjec9nt5je">
              <label className={styles.label} data-id="element-5761" data-mp="3g04cmlpdf8x8">Webhook type</label>
              <select value={webhookType} onChange={e => setWebhookType(e.target.value)} className={styles.input} data-id="element-5762" data-mp="17shc5y1okobt">
                <option value="All" data-id="element-5763" data-mp="1cl0sh2rr5xkb">All</option>
                <option value="Transaction-level" data-id="element-5764" data-mp="ysubxfkotokc">Transaction-level</option>
                <option value="Payment" data-id="element-5765" data-mp="13qmd70782n17">Payment</option>
                <option value="Refund" data-id="element-5766" data-mp="13r46bnyl8l4w">Refund</option>
                <option value="Dispute" data-id="element-5767" data-mp="1rfx4zs6lh737">Dispute</option>
                <option value="Settlement" data-id="element-5768" data-mp="1recag2ka5o5c">Settlement</option>
                <option value="Tokenisation" data-id="element-5769" data-mp="1vh0jobcwox2u">Tokenisation</option>
              </select>
            </div>
            <div data-id="element-5770" data-mp="1hhhglwyycbxe">
              <label className={styles.label} data-id="element-5771" data-mp="1hi0zph0c96d0">Transaction ID</label>
              <input type="text" value={transactionId} onChange={e => setTransactionId(e.target.value)} placeholder="Filter by transaction ID" className={styles.input} data-id="element-5772" data-mp="1mgaw1uxsud07" />
            </div>
          </div>}

        <div className="flex justify-center pt-2" data-id="element-5773" data-mp="3hcwz2knn16n">
          <button onClick={() => setShowAdditionalFilters(!showAdditionalFilters)} className={`${styles.link} flex items-center gap-1`} data-id="element-5774" data-mp="3uoz6vcxyvzvy">
            {showAdditionalFilters ? 'Hide Additional Filters' : 'Show Additional Filters'}
            {showAdditionalFilters ? <ChevronUp className="w-4 h-4" data-id="element-5775" data-mp="3g14drvg1rtic" /> : <ChevronDown className="w-4 h-4" data-id="element-5776" data-mp="3byhkdq3qa0j1" />}
          </button>
        </div>
      </div>

      {/* Active Filters Bar */}
      {activeFilters.length > 0 && <div className={`${styles.card} p-4 flex items-center justify-between`} data-id="element-5777" data-mp="3prz2d6grn56y">
          <div className="flex items-center gap-3 flex-wrap" data-id="element-5778" data-mp="3kxmcadksavm8">
            <span className={styles.subtext} data-id="element-5779" data-mp="2x8tgch45wnrm">Results filtered by:</span>
            {activeFilters.map(filter => <span key={filter.key} className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[var(--colors-primary-100)] text-[var(--colors-primary-800)] text-sm font-medium border border-[var(--colors-primary-200)]" data-id="element-5780" data-mp="2s9qknna2ntwb">
                {filter.value}
                <button onClick={() => removeFilter(filter.key)} className="text-[var(--colors-primary-400)] hover:text-[var(--colors-primary-700)] focus:outline-none ml-1" data-id="element-5781" data-mp="15xoub9fw5slk">
                  <X className="w-3.5 h-3.5" data-id="element-5782" data-mp="dauckkagl7bs" />
                </button>
              </span>)}
          </div>
          <button onClick={clearFilters} className={`${styles.btnGhost} px-3 py-1.5`} data-id="element-5783" data-mp="n6xcrklr2vw3">
            Clear search
          </button>
        </div>}

      {/* Table */}
      <div className={styles.card} data-id="element-5784" data-mp="1ymdn8l6smrm8">
        <div className="overflow-x-auto" data-id="element-5785" data-mp="1ylayait16z8y">
          <table className="w-full text-left text-sm text-[var(--colors-text-secondary)]" data-id="element-5786" data-mp="22nfo16gczbqb">
            <thead className="border-b border-[var(--colors-border-light)] bg-[var(--colors-background-card)]" data-id="element-5787" data-mp="22pad8wynxq07">
              <tr data-id="element-5788" data-mp="3j44zds46fdoo">
                <th className={styles.th} data-id="element-5789" data-mp="3j3mts4vmjn43">
                  <div className="flex items-center gap-2" data-id="element-5790" data-mp="3j4og55i3bw14">
                    Webhook type{' '}
                    <ArrowUpDown className="w-4 h-4 text-[var(--colors-text-tertiary)]" data-id="element-5791" data-mp="3ebbxrd408lgt" />
                  </div>
                </th>
                <th className={styles.th} data-id="element-5792" data-mp="34eqpmiwouu8r">
                  <div className="flex items-center gap-2" data-id="element-5793" data-mp="34fs0am9slepy">
                    URL{' '}
                    <ArrowUpDown className="w-4 h-4 text-[var(--colors-text-tertiary)]" data-id="element-5794" data-mp="2zeuiiasp2moz" />
                  </div>
                </th>
                <th className={styles.th} data-id="element-5795" data-mp="2vgep9p60si34">
                  <div className="flex items-center gap-2" data-id="element-5796" data-mp="2qfqy93hsk18w">
                    Timestamp{' '}
                    <ArrowUpDown className="w-4 h-4 text-[var(--colors-text-tertiary)]" data-id="element-5797" data-mp="tnh48fihitsq" />
                  </div>
                </th>
                <th className="px-6 py-3 font-medium text-[var(--colors-text-secondary)]" data-id="element-5798" data-mp="op5su0cjkb8e">
                  Request payload
                </th>
                <th className="px-6 py-3 font-medium text-[var(--colors-text-secondary)]" data-id="element-5799" data-mp="2hlh6xbip6ip">
                  Response
                </th>
                <th className={styles.th} data-id="element-5800" data-mp="3jx1rpcw90lis">
                  <div className="flex items-center gap-2" data-id="element-5801" data-mp="3jvyxow3mq2yn">
                    Status{' '}
                    <ArrowUpDown className="w-4 h-4 text-[var(--colors-text-tertiary)]" data-id="element-5802" data-mp="3ov38tsa46arm" />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-5803" data-mp="3ezrqkzzhylf4">
              {paginatedLogs.length === 0 ? <tr data-id="element-5804" data-mp="30zqq3ln59g06">
                  <td colSpan={6} className="px-6 py-24 text-center" data-id="element-5805" data-mp="3108whb3italt">
                    <div className="flex flex-col items-center justify-center" data-id="element-5806" data-mp="35y250asaqgp9">
                      <div className="w-12 h-12 bg-[var(--colors-neutral-50)] rounded-full flex items-center justify-center mb-4" data-id="element-5807" data-mp="z7ui2m06qoa5">
                        <Clock className="w-6 h-6 text-[var(--colors-text-tertiary)]" data-id="element-5808" data-mp="14774x6r23vcq" />
                      </div>
                      <h3 className={`text-base font-medium text-[var(--colors-text-primary)] mb-1`} data-id="element-5809" data-mp="2oprdakprvoj2">
                        No webhook logs
                      </h3>
                      <p className={styles.subtext} data-id="element-5810" data-mp="2ygc7lvyey6w6">
                        Webhook events for this merchant will appear here.
                      </p>
                    </div>
                  </td>
                </tr> : paginatedLogs.map(log => <Fragment key={log.id} data-id="element-5811" data-mp="32fl2j456watb">
                    <tr className="border-b border-[var(--colors-neutral-100)] hover:bg-[var(--colors-neutral-50)]" data-id="element-5812" data-mp="3hdn79hnyj2c5">
                      <td className="px-6 py-3" data-id="element-5813" data-mp="3cetuxskephdk">
                        <span className={`${styles.badgeBase} bg-[var(--colors-primary-100)] text-[var(--colors-primary-800)] border-[var(--colors-primary-200)]`} data-id="element-5814" data-mp="3cfbxf6xnwrtx">
                          {log.webhookType}
                        </span>
                      </td>
                      <td className="px-6 py-3 font-mono text-xs text-[var(--colors-text-tertiary)]" title={log.url} data-id="element-5815" data-mp="3b3rv99i140zq">
                        {truncateUrl(log.url)}
                      </td>
                      <td className="px-6 py-3 text-[var(--colors-text-secondary)]" data-id="element-5816" data-mp="3fxw45yauuj3g">
                        {log.timestamp}
                      </td>
                      <td className="px-6 py-3" data-id="element-5817" data-mp="2n7xbzu1d65uk">
                        <button onClick={() => togglePayload(log.id)} className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-xs font-medium border transition-colors ${expandedPayloads[log.id] ? 'bg-[var(--colors-primary-100)] text-[var(--colors-primary-800)] border-[var(--colors-primary-200)]' : 'bg-[var(--colors-neutral-50)] text-[var(--colors-text-secondary)] border-[var(--colors-border-light)] hover:bg-[var(--colors-neutral-100)]'}`} data-id="element-5818" data-mp="2n97agkc4pg1q">
                          View <Eye className="w-3.5 h-3.5" data-id="element-5819" data-mp="k1q68y2damb2" />
                        </button>
                      </td>
                      <td className="px-6 py-3" data-id="element-5820" data-mp="ayyraoaa98eo">
                        <button onClick={() => toggleResponse(log.id)} className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-xs font-medium border transition-colors ${expandedResponses[log.id] ? 'bg-[var(--colors-primary-100)] text-[var(--colors-primary-800)] border-[var(--colors-primary-200)]' : 'bg-[var(--colors-neutral-50)] text-[var(--colors-text-secondary)] border-[var(--colors-border-light)] hover:bg-[var(--colors-neutral-100)]'}`} data-id="element-5821" data-mp="b09xeur7as8y">
                          View <Eye className="w-3.5 h-3.5" data-id="element-5822" data-mp="1loqw0tkqbfcm" />
                        </button>
                      </td>
                      <td className="px-6 py-3" data-id="element-5823" data-mp="1qfzai40x1qwn">
                        <span className={`${styles.badgeBase} ${statusBadgeColor(log.httpStatus)}`} data-id="element-5824" data-mp="1qgqv6jsz6485">
                          {log.httpStatus} {log.httpStatusText}
                        </span>
                      </td>
                    </tr>

                    {expandedResponses[log.id] && <tr className="border-b border-[var(--colors-neutral-100)]" data-id="element-5825" data-mp="1mc6jm7xt5kku">
                        <td colSpan={6} className="px-6 py-4" data-id="element-5826" data-mp="1hcbqryuh2kx5">
                          <p className="text-sm font-medium text-[var(--colors-text-secondary)] mb-2" data-id="element-5827" data-mp="1hdv9rx7ija2m">
                            Response body
                          </p>
                          <pre className="bg-[var(--colors-neutral-800)] text-[var(--colors-neutral-100)] rounded-lg p-4 text-xs font-mono overflow-x-auto leading-relaxed" data-id="element-5828" data-mp="18l1q7nl19oiy">
                            {JSON.stringify(log.responseBody, null, 4)}
                          </pre>
                        </td>
                      </tr>}

                    {expandedPayloads[log.id] && <tr className="border-b border-[var(--colors-neutral-100)]" data-id="element-5829" data-mp="jij4uegypbv9">
                        <td colSpan={6} className="px-6 py-4" data-id="element-5830" data-mp="oh486mrigbnx">
                          <p className="text-sm font-medium text-[var(--colors-text-secondary)] mb-2" data-id="element-5831" data-mp="thi2z343pp40">
                            Request payload
                          </p>
                          <pre className="bg-[var(--colors-neutral-800)] text-[var(--colors-neutral-100)] rounded-lg p-4 text-xs font-mono overflow-x-auto leading-relaxed" data-id="element-5832" data-mp="ye8r8dq27r0i">
                            {JSON.stringify(log.requestPayload, null, 4)}
                          </pre>
                        </td>
                      </tr>}
                  </Fragment>)}
            </tbody>
          </table>
        </div>

        <div className="px-6 py-4 border-t border-[var(--colors-border-light)] bg-[var(--colors-neutral-50)] flex items-center justify-between rounded-b-lg" data-id="element-5833" data-mp="3e6obyxsficz1">
          <div className="text-sm text-[var(--colors-text-tertiary)] font-medium" data-id="element-5834" data-mp="1oq2gmnt620by">
            {filteredLogs.length === 0 ? 'No entries' : `Showing ${startEntry}-${endEntry} of ${filteredLogs.length} ${filteredLogs.length === 1 ? 'entry' : 'entries'}`}
          </div>
          <div className="flex items-center gap-4" data-id="element-5835" data-mp="1tpow73wgvsnx">
            <div className="flex items-center gap-2" data-id="element-5836" data-mp="1tnub9pl740ju">
              <span className="text-sm text-[var(--colors-text-tertiary)] font-medium" data-id="element-5837" data-mp="27gafuutqw6mv">
                Show
              </span>
              <select value={perPage} onChange={e => {
              setPerPage(Number(e.target.value));
              setCurrentPage(1);
            }} className="border border-[var(--colors-border-default)] rounded-md text-sm py-1.5 pl-3 pr-8 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primaryring)] bg-[var(--colors-background-card)]" data-id="element-5838" data-mp="23egh4s341cpc">
                <option value={25} data-id="element-5839" data-mp="i3zyj2fu40we">25</option>
                <option value={50} data-id="element-5840" data-mp="2topebj7dkf63">50</option>
                <option value={100} data-id="element-5841" data-mp="2tq0oc0reyj5n">100</option>
              </select>
            </div>
            <div className="flex items-center gap-1" data-id="element-5842" data-mp="2ynsiz2jg0jdj">
              <button onClick={() => setCurrentPage(Math.max(1, currentPage - 1))} className="p-1 text-[var(--colors-text-tertiary)] hover:text-[var(--colors-text-secondary)] disabled:opacity-50" disabled={currentPage <= 1} data-id="element-5843" data-mp="2jzz1tdepl8su">
                <ChevronLeft className="w-4 h-4" data-id="element-5844" data-mp="2fxkiytb1i91k" />
              </button>
              <span className="text-sm font-medium text-[var(--colors-text-secondary)] px-2" data-id="element-5845" data-mp="2fvrbxcwilmt1">
                {currentPage}
              </span>
              <button onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))} className="p-1 text-[var(--colors-text-tertiary)] hover:text-[var(--colors-text-secondary)] disabled:opacity-50" disabled={currentPage >= totalPages} data-id="element-5846" data-mp="25yuz4uzl2eio">
                <ChevronRight className="w-4 h-4" data-id="element-5847" data-mp="2sfi2bk43xq3" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}